import React, { useState } from "react";
import { getHash } from "lib/routing";
import { isMobile } from "lib/hooks/useIsMobile";

export const CategoryLinks = ({ categories, cardRefs }) => {
  const initialCategory = getHash().replace(/_/g, " ");
  const [activeCategory, setActiveCategory] = useState(initialCategory);

  return (
    <section className="category-links">
      <ul>
        {categories.map((category, index) => (
          <CategoryLink
            key={index}
            category={category}
            activeCategory={activeCategory}
            setActiveCategory={setActiveCategory}
            cardRefs={cardRefs}
          />
        ))}
      </ul>
    </section>
  );
};

export const CategoryLink = ({ category, activeCategory, setActiveCategory, cardRefs }) => {
  const active = category === activeCategory ? "active" : "";
  const categoryId = category.replace(/ /g, "_");
  const hash = `#${categoryId}`;
  const containerId = `${categoryId}-link`;
  const node = cardRefs?.[categoryId]?.current;

  return (
    <div className={"p-2 pl-3 scrollspy " + active} id={containerId}>
      <h5 className="font-weight-light">
        <a
          href={hash}
          onClick={(e) => {
            if (isMobile()) {
              return;
            }

            e.preventDefault();

            setActiveCategory(category);
            window.scrollTo(0, node.offsetTop + 520);
            history.replaceState(undefined, "", hash);
          }}
        >
          {category}
        </a>
      </h5>
    </div>
  );
};
